<template>
  <mm-tab-title>
      <div>
      <el-form ref="form" size="small" label-width="200px">
          <el-form-item label="Account" prop="token">
            <mm-dict-select v-model="afForm.token" dictType="afToken" style="width:300px;"></mm-dict-select>
          </el-form-item>
          <el-form-item label="App Id" prop="app_id">
            <el-input v-model.trim="afForm.app_id" style="width:300px;"/>
          </el-form-item>
          <el-form-item label="Date Range">
            <el-date-picker
              style="width:300px;"
              v-model="dateRange"
              type="daterange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              range-separator="-">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <div>
              <el-button slot="save" size="medium" type="primary" @click="submit">Event</el-button>
              <el-button slot="save" size="medium" type="primary" @click="submit2">Install</el-button>
            </div>
          </el-form-item>
      </el-form>

      </div>
  </mm-tab-title>


</template>

<script>
export default {
data() {
  return {
    afForm: {
      token: '',
      app_id: ''
    },
    dateRange: [],
    pickerOptions: {
      shortcuts: [
        {
            text: 'Today',
            onClick: this.daysPeriod(0)
        },
        {
            text: 'yesterday',
            onClick: this.yesterdayPeriod()
        },
        {
            text: 'Last 3 days',
            onClick: this.daysPeriod(3)
        },
        {
            text: 'Last 7 days',
            onClick: this.daysPeriod(7)
        },
        {
            text: 'Last 30 days',
            onClick: this.daysPeriod(30)
        },
        {
            text: 'This Month',
            onClick: this.monthPeriod(0)
        },
        {
            text: 'Last Month',
            onClick: this.monthPeriod(1)
        },
      ],
    },
  };
},
methods: {
  async submit() {
    if (!this.afForm.token || !this.dateRange.length || !this.afForm.app_id) {
      this.$message.error('Missing Param');
      return;
    }
    this.$post('/tool/getAffEventCsv', {
      ...this.afForm,
      start_date: this.dateRange[0],
      end_date: this.dateRange[1],
    }, {
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `afEventLog_${this.dateRange[0]}/${this.dateRange[1]}.csv`); // 设置下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
  },
  async submit2() {
    if (!this.afForm.token || !this.dateRange.length || !this.afForm.app_id) {
      this.$message.error('Missing Param');
      return;
    }
    this.$post('/tool/getAffInstallCsv', {
      ...this.afForm,
      start_date: this.dateRange[0],
      end_date: this.dateRange[1],
    }, {
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `afInstallLog_${this.dateRange[0]}/${this.dateRange[1]}.csv`); // 设置下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
  },
  daysPeriod(num){
      return function(picker){
          this.dateRange = [];
          const end = new Date().setHours(23, 59, 59, 0);
          const start = end - 86400000 * num - 23 * 3600000 - 3600000 + 1000;
          this.dateRange[0] = new Date(start);
          this.dateRange[1] = new Date(end);
          picker.$emit('pick',this.dateRange);
      }
  },
  yesterdayPeriod(){
      return function(picker){
          this.dateRange = [];
          const timestamp = new Date().setHours(0, 0, 0, 0) ;
          this.dateRange[0] = new Date(timestamp - 86400000);
          this.dateRange[1] = new Date(timestamp - 1000);
          picker.$emit('pick',this.dateRange);
      }
  },
  monthPeriod(num){
      return function(picker){
          this.dateRange = [];
          const date = new Date();
          const y = date.getFullYear();
          const m = date.getMonth() - num;
          this.dateRange[0] = new Date(y,m,1);
          this.dateRange[1] = new Date(y,m+1,0,23,59,59);
          picker.$emit('pick',this.dateRange);
      }
  },
},
};
</script>